import React, { useState, useEffect } from "react";
import Footer from "../../../../components/shared/Footer";

import CaseSearchResults from "./components/CaseSearchResults";
import CaseInformation from "./components/CaseSerachInformation";
import * as APIModels from "../../../../models";
import { authenticationService } from "../../../../services/authentication.service";

type MyOptionType = { label: string; value: string };

export default function TylerCaseSearch() {
    const portal = authenticationService.portalValue;
    const [cases, setCases] = useState([] as APIModels.CourtCase[]);
    const [completedSubmission, setCompletedSubmission] = useState(
        {} as APIModels.Submission
    );

    const submission = {
        portalIdentifier: portal,
        attorneyID: "80BE7F23-3F19-44C6-9BAF-49D28DF3A91B",
        caseData: {} as APIModels.CaseData,
    } as APIModels.Submission;

    const onSearchComplete = (
        request: APIModels.CaseSearch,
        result: APIModels.CourtCase
    ) => {
        const updatedCaseData =
            completedSubmission.caseData ?? new APIModels.CaseData();
        updatedCaseData.ucn = result.ucn;
        updatedCaseData.county = result.county;
        updatedCaseData.countyID = request.countyID;
        updatedCaseData.division = result.division;
        updatedCaseData.divisionID =
            result.divisionID != APIModels.EmptyGuid
                ? result.divisionID
                : request.divisionID;
        updatedCaseData.courtCaseNumber =
            result.caseNumber ?? request.caseNumber;
        updatedCaseData.caseTitle = result.caseTitle;
        updatedCaseData.caseTypeID = result.caseTypeID;
        updatedCaseData.caseSubTypeID = result.caseSubTypeID;
        updatedCaseData.year = request.year;
        updatedCaseData.sequenceNumber = request.sequenceNumber;

        setCompletedSubmission({
            ...submission,
            caseData: updatedCaseData,
            parties: result.parties,
        });
        setCases([result]);
    };

    const onCourtCasesFound = (courtCases: APIModels.CourtCase[]) => {
        console.log(courtCases);
        setCases(courtCases);
    };

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Firms</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">Cases</a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Case Search
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-6">
                        <CaseInformation
                            submission={submission}
                            onSearchComplete={onSearchComplete}
                            setCases={onCourtCasesFound}
                        />
                    </div>
                    <div className="col-6">
                        <CaseSearchResults cases={cases} />
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
